'use strict';
import request from '@/api/fetch';
import APIURL from '_libs/APIURL';
import { getObjVal, typeOf } from 'tools';
export default {
    config: {
        pageHeight: 0,
        pageParams: {
            referNode: '.app-wrapper .sidebar-wrapper',
            referDiff: 50,
        },
    },
    API: {
        request,
        APIURL,
    },
};



// WEBPACK FOOTER //
// ./src/libs/API.js